import './style.css'

export default class ContactPage {
    static selector = '.contact-page';

    constructor(block) {
        this.block = block;
    }
}
